// src/redux/slices/lokiLoggingSlice.ts
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { LokiLoggingState, LokiFilters } from '../types/lokiLoggingTypes';
import dayjs from 'dayjs';

const DEFAULT_TIME_RANGE = '2d';

const initialState: LokiLoggingState = {
    filters: {
        environment: '',
        namespace: [],
        application: [],
        level: [],
        searchPattern: '',
        timeRange: DEFAULT_TIME_RANGE,
        customer: '',
        location: '',
        startDate: dayjs(Date.now() - 15 * 60 * 1000).toISOString(),
        endDate: dayjs().toISOString(),
    },
};

const lokiLoggingSlice = createSlice({
    name: 'lokiLogging',
    initialState,
    reducers: {
        setLokiFilters(state, action: PayloadAction<Partial<LokiFilters>>) {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetLokiFilters(state) {
            state.filters = initialState.filters;
        },
        setLokiEnvironment(state, action: PayloadAction<string>) {
            state.filters.environment = action.payload;
        },
        setLokiNamespace(state, action: PayloadAction<string[]>) {
            state.filters.namespace = action.payload;
        },
        setLokiApplication(state, action: PayloadAction<string[]>) {
            state.filters.application = action.payload;
        },
        setLokiLevel(state, action: PayloadAction<string[]>) {
            state.filters.level = action.payload;
        },
        setLokiSearchPattern(state, action: PayloadAction<string>) {
            state.filters.searchPattern = action.payload;
        },
        setLokiTimeRange(state, action: PayloadAction<string>) {
            state.filters.timeRange = action.payload;
        },
        setLokiCustomer(state, action: PayloadAction<string>) {
            state.filters.customer = action.payload;
        },
        setLokiLocation(state, action: PayloadAction<any>) {
            state.filters.location = action.payload;
        },
        setLokiStartDate(state, action: PayloadAction<string>) {
            state.filters.startDate = action.payload;
        },
        setLokiEndDate(state, action: PayloadAction<string>) {
            state.filters.endDate = action.payload;
        },
    },
});

export const {
    setLokiFilters,
    resetLokiFilters,
    setLokiEnvironment,
    setLokiNamespace,
    setLokiApplication,
    setLokiLevel,
    setLokiSearchPattern,
    setLokiTimeRange,
    setLokiCustomer,
    setLokiLocation,
    setLokiStartDate,
    setLokiEndDate,
} = lokiLoggingSlice.actions;

export default lokiLoggingSlice.reducer;
